/** Hostname where users authenticate via Google Workspace; session exits return there instead of in-app login. */
export const GRAZITTI_GRIGO_HOSTNAME = 'grigo.grazitti.com';

const GOOGLE_WORKSPACE_DASHBOARD = 'https://workspace.google.com/dashboard';

export function isGrazittiGrigoHostname(): boolean {
  return typeof window !== 'undefined' && window.location.hostname === GRAZITTI_GRIGO_HOSTNAME;
}

export function isExternalAuthSession(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    new URLSearchParams(window.location.search).get('external') === 'true' ||
    sessionStorage.getItem('external') === 'true'
  );
}

/**
 * Target URL when the app should leave the authenticated shell (logout, idle timeout, 401, SSO failure).
 * Embedded (`external`) sessions always return to the login page with the flag; Grazitti production returns
 * to Google Workspace; all other hosts use the app login page.
 */
export function getUnauthenticatedRedirectUrl(): string {
  if (isExternalAuthSession()) {
    return `${window.location.origin}/login?external=true`;
  }
  if (isGrazittiGrigoHostname()) {
    return GOOGLE_WORKSPACE_DASHBOARD;
  }
  return `${window.location.origin}/login`;
}

export function redirectToUnauthenticatedLanding(): void {
  window.location.assign(getUnauthenticatedRedirectUrl());
}
